<div class="container">
  <div
    class="error"
    *ngIf="error"
  >
    {{ error }}
  </div>

  <div
    class="empty-state"
    *ngIf="!error && emptyState"
  >
    <div class="empty-state-line">Remove filters or try a different search.</div>
    <div
      class="empty-state-line"
      *ngIf="showCustomRequestEmptyState"
    >
      Still can't find what you're looking for?
      <button
        mat-flat-button
        color="accent"
        class="merri-icon-button"
        (click)="onCustomRequestClick()"
      >
        <mat-icon
          [svgIcon]="brandingService.logoMarkOutlineIcon"
          *ngIf="showLock"
        ></mat-icon>
        Request a custom item
      </button>
    </div>
  </div>
  <div class="drop-list-container merri-scrollbar-gray">
    <div
      class="results-grid"
      cdkDropList
      cdkDropListSortingDisabled
    >
      <button
        [class.disabled]="showLock"
        class="blank-button add-button"
        (click)="onAddItemClick()"
        *ngIf="showCustomUploadSearchResult && !placeholderItems && !emptyState"
        matTooltip="Upload your own item"
        matTooltipShowDelay="400"
        merriNoFocusLink
      >
        <mat-icon
          class="plus-icon"
          svgIcon="plus"
        ></mat-icon>
        <mat-icon
          class="lock-icon"
          *ngIf="showLock"
          [svgIcon]="brandingService.upgradeAllAccessBadgeIcon"
        ></mat-icon>
      </button>
      <app-visionboard-item-search-result-item
        *ngFor="let item of items"
        class="visionboard-item-search-result-item"
        [disableDrag]="itemDragDisabled(item)"
        [allowDupes]="allowDupes"
        [showUserSelected]="showUserSelected"
        [forceVisionboardItemAddRemoveButton]="forceVisionboardItemAddRemoveButton"
        [customAddRemoveTemplate]="itemCustomAddRemoveTemplate"
        [item]="item"
        cdkDrag
        [cdkDragData]="item"
        (cdkDragStarted)="onDragStart($event, item)"
        (cdkDragReleased)="onDragReleased($event, item)"
        (cdkDragMoved)="onDragMoved($event, item)"
        [cdkDragDisabled]="itemDragDisabled(item)"
        [matTooltip]="itemToolTipText"
        [matTooltipDisabled]="itemDragDisabled(item)"
        matTooltipPosition="below"
        matTooltipShowDelay="1500"
        (itemClicked)="onItemClick(item)"
        (itemDialogOpened)="onItemDialogOpened($event)"
        [class.loading]="item.placeholder"
        [disabled]="itemDisabled(item)"
        [showLock]="showLock && item.isCustomerUploadedSku"
        [source]="source"
        cdkOverlayOrigin
        #origin="cdkOverlayOrigin"
      >
        <app-visionboard-workspace-item
          class="visionboard-workspace-item-preview"
          [item]="item.getVisionboardItem()"
          [removable]="false"
          *cdkDragPreview
        ></app-visionboard-workspace-item>
      </app-visionboard-item-search-result-item>
    </div>
  </div>
  <app-paginator
    class="paginator"
    [totalCount]="itemCount"
    [pageSize]="pageSize"
    [class.hidden]="initialLoad"
    [pageIndex]="lastPageIndex"
    (paged)="onPage($event)"
    *ngIf="showBottomPaginator"
  ></app-paginator>
</div>
